import styled from 'styled-components';
import theme from './../theme';
import { Link } from "react-router-dom";
import {ReactComponent as IconoFlecha} from './../imagenes/refrescar.svg';

const Lista = styled.ul`
    list-style: none;
    padding: 0 1rem; /* 40px */
    height: 100%;
    overflow-y: auto;
 
    li {
        grid-template-columns: 0.2fr 0.3fr 1fr 4fr;
    }
 
    @media (max-width: 50rem) { /*80px*/
        li {
            grid-template-columns: 0.3fr 1fr;
            grid-template-rows: 1fr 2fr;
        }
    }
`;
 
const Lista2 = styled.ul`
    list-style: none;
    padding: 0 1rem; /* 40px */
    height: 100%;
    overflow-y: auto;
 
    li {
        grid-template-columns: 0.2fr 0.3fr 0.3fr 0.7fr 4fr;
    }
 
    @media (max-width: 50rem) { /*80px*/
        li {
            grid-template-columns: 0.3fr 1fr;
            grid-template-rows: 1fr 2fr;
        }
    }
`;

const ElementoLista = styled.li`
    padding: 0.1rem 0; /* 20px */
    border: 2px solid #F2F2F2;
    border-bottom: 1px solid #c6c6c6;
    border-radius: 1rem; /* 5px */
    display: grid;
    width: 100%;
    gap: 0.31rem; /* 5px */
    justify-content: space-between;
    text-transform: uppercase;
    & > div {
        width: 100%;
        display: flex;
        align-items: center;
    }
 
    &:hover button,
    &:hover a {
        opacity: 1;
    }
`;
 
const ElementoListad = styled.li`
    padding: 0.25rem 0; /* 20px */
    border-bottom: 2px solid #F2F2F2;
    width: 100%;
    gap: 0.31rem; /* 5px */
    justify-content: space-between;
    text-transform: uppercase;
    & > div {
        width: 100%;
        display: flex;
        align-items: center;
    }
 
    &:hover button,
    &:hover a {
        opacity: 1;
    }
`;
 
const ListaDeCategorias = styled.ul`
    list-style: none;
    padding: 0 2.5rem; /* 40px */
    height: 100%;
    overflow-y: auto;
`;
 
const ElementoListaCategorias = styled.li`
    padding: 1.25rem 0; /* 20px */
    border-bottom: 2px solid #F2F2F2;
    display: flex;
    justify-content: space-between;
    text-transform: uppercase;
`;
 
const Categoria = styled.div`
    font-weight: 500;
    font-size: 1.25rem; /* 20px */
    text-transform: uppercase;
    display: flex;
    align-items: center;
    
    svg {
        width: 3.12rem; /* 50px */
        height: auto;
        margin-right: 1.25rem; /* 20px */
        border-radius: 0.62rem; /* 10px */
    }
 
    @media (max-width: 50rem) { /* 80px */
        font-size: 1.12rem;
    }
`;
 
const Descripcion = styled.div`
    justify-content: left;
    font-size: 1rem;
    text-transform: uppercase;
    @media (max-width: 20rem) { /* 50px */
        justify-content: end;
        font-size: 1rem;
    }
`;
 
const Valor = styled.div`
    font-size: 1.25rem; /* 20px */
    font-weight: 700;
    justify-content: end;
 
    @media (max-width: 50rem) { /* 80px */
        justify-content: start;
    }
`;
 
const Fecha = styled.div`
    border-radius: 0.31rem; /* 5px */
    background: ${theme.azulClaro};
    text-align: center;
    color: #fff;
    padding: 0.62rem 0.5rem; /* 10px 50px */
    display: inline-block;
    margin: 0.5rem 0; /* 20px */
    text-transform: uppercase;
    @media (max-width: 50rem) { /* 80px */
        width: 100%;
    }
`;
 
const ContenedorBotonesl = styled.div`
    @media (max-width: 50rem) { /* 80px */
        justify-content: end;
    }
`;
 
const BotonAccion = styled.button`
    outline: none;
    background: ${theme.grisClaro};
    border: none;
    width: 2rem; /* 40px */
    display: inline-block;
    height: 2rem; /* 40px */
    line-height: 2rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    border-radius: 0.31rem; /* 5px */
    margin-left: 0.625rem; /* 10px */
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
 
    &:hover {
        background: ${theme.grisClaro2};
    }
 
    svg {
        width: 1.125rem; /* 18px */
    }
 
    @media (max-width: 50rem) { /* 80px */
        opacity: 1;
    }
`;
 
const ContenedorSubtitulo = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-transform: uppercase;
`;
 
const Subtitulo = styled.h3`
    color: ${theme.grisClaro2};
    font-weight: 400;
    font-size: 40px;
    padding: 2.5rem 0; /* 40px */
    text-transform: uppercase;
`;
 
const ContenedorBotonCentral = styled.div`
    display: flex;
    justify-content: center;
    margin: 2.5rem; /* 40px */
`;
 

const BotonCargarMas = styled.button`
    background: ${theme.grisClaro};
    border: none;
    border-radius: 7px;
    color: #000;
    font-family: 'Work Sans', sans-serif;
    padding: 1rem 1.87rem; /* 20px 30px */
    
    font-size: 1.25rem; /* 20px */
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    outline: none;
    transition: .3s ease all;
 
    &:hover {
        background: ${theme.grisClaro2};
    }
`;

const Boton = styled(Link)`
    background: ${(props) => props.primario ? '#5B69E2' : '#001089'};
    width: ${(props) => props.conIcono ? '15.62rem' : 'auto'}; /* 250px */
    margin-left: 1.25rem; /* 20px */
    border: none;
    border-radius: 0.625rem; /* 10px */
    color: #fff;
    font-family: 'Work Sans', sans-serif;
    height: 2rem; /* 60px */
    padding: 1.25rem 1.87rem; /* 20px 30px */
    font-size: 1.25rem; /* 20px */
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    outline: none;
 
    svg {
        height: ${(props) => props.iconogrande ? '100%' : '0.75rem;'};  /* 12px */
        fill: white;
    }
    &:hover {
        background: ${theme.grisClaro2};
    }
`;

const BotonOpciones = styled(Link)`
    background: ${(props) => props.primario ? '#5B69E2' : '#001089'};
    width: 20rem; /* 250px */
    margin-left: 0.25rem; /* 20px */
    border: none;
    border-radius: 0.625rem; /* 10px */
    color: #fff;
    font-family: 'Work Sans', sans-serif;
    height: 2rem; /* 60px */
    padding: 1.25rem 1.87rem; /* 20px 30px */
    font-size: 1.25rem; /* 20px */
    font-weight: 200;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    outline: none;
    margin-top: 0.5rem; /* 10px */
    svg {
        height: ${(props) => props.iconogrande ? '100%' : '0.75rem;'};  /* 12px */
        fill: white;
    }
`;


const Input = styled.input`
    font-size: 1rem; /* 40px */
    text-transform: uppercase;
    border-radius: 10px;
    border: none;
    width: 40px;
    height: 30px;
    margin: 0.1rem 0;  /* 40px */
    border: 2px solid ${theme.grisClaro2};
    outline: none;
    text-align: center;
    @media(max-width: 60rem){ /* 950px */
        font-size: 1 rem; /* 24px */
    }
`;
const ContenedorFiltro = styled.div`
    height: 100%; /* 80px */
    width: 100%;
    margin-bottom: 1rem; /* 30px */
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    justify-content: left;
    margin: 0.5rem; /* 40px */
`;
const ContenedorFiltroMoviles = styled.div`
    justify-content: space-between;
    display: grid;
    height: auto; /* 80px */
    width: 100%;
    grid-template-columns: 10fr 2fr 0.1fr;
    margin-bottom: 0rem; /* 30px */
    
`;


const ContenedorFiltroDoble = styled.div`
    justify-content: space-between;
    display: grid;
    grid-template-columns: 6fr 1fr ;
    margin-bottom: 0.2rem; /* 30px */
    @media(max-width: 60rem){ /* 950px */
        flex-direction: column;
 
        & > * {
            width: 100%;
            margin-bottom: 0.2rem; /* 10px */
        }
    }
`;

const BotonFiltro = styled.button`
    background: ${theme.grisClaro};
    border: none;
    border-radius: 5px;
    color: #000;
    font-family: 'Work Sans', sans-serif;
    padding: 0.5rem 0.5rem; /* 20px 30px */
    margin: 0rem 0.5rem; /* 40px */
    font-size: 1rem; /* 20px */
    font-weight: 200;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    justify-content: left;
    align-items: left;
    outline: none;
    transition: .3s ease all;
    height: 2rem; /* 40px */    
    width: 6rem; /* 40px */
    &:hover {
        background: ${theme.grisClaro2};
    }
`;
const ContenedorFiltros = styled.div`
    justify-content: space-between;
    align-items: center;
    top:70px; 
    left:0;
    border: 2px solid #F2F2F2;
    display: grid;
    grid-template-columns: 1fr 3fr 1fr 3fr 1fr ;
    margin-bottom: 0.2rem; /* 30px */
    @media(max-width: 60rem){ /* 950px */
        flex-direction: column;
 
        & > * {
            width: 100%;
            margin-bottom: 0.2rem; /* 10px */
        }
    }
`;

const ContenedorFiltrosTerminados = styled.div`
    justify-content: space-between;
    align-items: center;
    top:70px; 
    left:0;
    height: 6rem; /* 80px */
    width: 100%;
    border: 2px solid #F2F2F2;
    display: grid;
    grid-template-columns: 3fr 3fr 1fr;
    margin-bottom: 1rem; /* 30px */
    @media(max-width: 60rem){ /* 950px */
        flex-direction: column;
 
        & > * {
            width: 100%;
            margin-bottom: 0.2rem; /* 10px */
        }
    }
`;


const ContenedorFiltrosActivos = styled.div`
    justify-content: space-between;
    align-items: center;
    top:70px; 
    left:0;
    height: 6rem; /* 80px */
    width: 100%;
    border: 2px solid #F2F2F2;
    display: grid;
    grid-template-columns: 3fr 3fr 3fr 2fr;
    margin-bottom: 1rem; /* 30px */
    @media(max-width: 60rem){ /* 950px */
        flex-direction: column;
        & > * {
            width: 100%;
            margin-bottom: 0.2rem; /* 10px */
        }
    }
`;


const ContenedorSubtituloPequeño = styled.div`
    height: 40px;
    display: flex;
    width: 60rem; /* 40px */
    border-radius: 0.31rem; /* 5px */
    align-items: center;
    margin-bottom: 0.5rem; /* 30px */
    justify-content: center;
    flex-direction: column;
`;
const FormularioApp = styled.form`
    padding: 0 2.5rem; /* 40px */
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: top;
    input {
        text-align: center;
        padding: 1 rem 0;
        height: 3rem; /* 80px */
        font-family: 'Work Sans', sans-serif;
        &::placeholder {
            color: rgba(0,0,0,.2);
        }
    }
 
    @media(max-width: 60rem){ /* 950px */
        justify-content: start;
    }
`;

const ContenedorSubtituloPequeño2 = styled.div`
    background: ${theme.grisClaro};    
    height: 2.5rem;
    display: flex;
    width: 44rem; /* 40px */
    border-radius: 0.31rem; /* 5px */
    align-items: center;
    margin-bottom: 0.5rem; /* 30px */
    margin-top: 0.5rem; /* 30px */
    justify-content: center;
    flex-direction: column;
    font-size: 1.2rem; /* 20px */
    font-weight: 200;
`;
const ContenedorTotal = styled.div`
    height: 100%; /* 80px */
    width: 100%;
    align-items: top;
`;

const ContenedorFiltroBusqueda = styled.div`
    justify-content: space-between;
    display: grid;
    height: auto; /* 80px */
    width: 100%;
    grid-template-columns: 8fr 8fr;
    margin-bottom: 0rem; /* 30px */
    align-items: top;
`;

const ContenedorInputconLabel = styled.div`
    width: 100%;
    height: 2rem; /* 80px */

`;
const Input2 = styled.input`
    font-size: 1rem; /* 40px */
    text-transform: uppercase;
    border-radius: 10px;
    border: none;
    width: 100%;
    margin: 0.1rem 0;  /* 40px */
    border-bottom: 2px solid ${theme.grisClaro2};
    outline: none;
    height: 2.5rem; /* 80px */
    @media(max-width: 60rem){ /* 950px */
        font-size: 1 rem; /* 24px */
    }
`;
const ContenedorDoble = styled.div`
    justify-content: space-between;
    display: grid;
    grid-template-columns: 3fr 3fr ;
    margin-bottom: 0.2rem; /* 30px */
    @media(max-width: 60rem){ /* 950px */
        flex-direction: column;
         & > * {
            width: 100%;
            margin-bottom: 0.2rem; /* 10px */
        }
    }
`;
const BotonsRecarga = styled(Link)`
display: block;
width: 3.12rem; /* 50px */
height: 3.12rem; /* 50px */
line-height: 3.12rem; /* 50px */
text-align: center;
margin-right: 1.25rem; /* 20px */
border: none;
background: #001089;
color: #fff;
display: flex;
align-items: center;
justify-content: center;
border-radius: 0.31rem; /* 5px */
cursor: pointer;

@media(max-width: 60rem){ /* 950px */
    width: 2.5rem; /* 40px */
    height: 2.5rem; /* 40px */
    line-height: 2.5rem; /* 40px */
}

`;

const BotonNavegador = styled(Link)`
display: block;
width: 6.24rem; /* 50px */
height: 3.12rem; /* 50px */
line-height: 3.12rem; /* 50px */
text-align: center;
margin-right: 0.25rem; /* 20px */
border: none;
background: #001089;
color: #fff;
display: flex;
align-items: center;
justify-content: center;
border-radius: 0.31rem; /* 5px */
cursor: pointer;

@media(max-width: 60rem){ /* 950px */
    width: 2.5rem; /* 40px */
    height: 2.5rem; /* 40px */
    line-height: 2.5rem; /* 40px */
}

`;


const Icono = styled(IconoFlecha)`
    width: 50%;
    height: auto;
    fill: #fff;
`;

const ContenedorNavegador = styled.div`
    justify-content: center;
    align-items: center;
    height: 100%
    width: 15rem;
    display: grid;
    grid-template-columns: 1fr 1fr 2fr 2fr;
    
`;

export {
    ContenedorNavegador,
    BotonNavegador,
    BotonsRecarga,
    Icono,
    Input2,
    ContenedorFiltros,
    ContenedorFiltro,
    BotonFiltro,
    Input,
    Lista,
    ElementoLista,
    ListaDeCategorias,
    ElementoListaCategorias,
    Categoria,
    Descripcion,
    Valor,
    Fecha,
    ElementoListad,
    ContenedorBotonesl,
    BotonAccion,
    BotonCargarMas,
    ContenedorBotonCentral,
    ContenedorSubtitulo,
    Subtitulo,
    Boton,
    ContenedorFiltroDoble,
    ContenedorFiltroMoviles,
    BotonOpciones,
    ContenedorSubtituloPequeño,
    FormularioApp,
    ContenedorSubtituloPequeño2,
    Lista2,
    ContenedorFiltroBusqueda,
    ContenedorTotal,
    ContenedorFiltrosTerminados,
    ContenedorInputconLabel,
    ContenedorFiltrosActivos,
    ContenedorDoble
};